export const API_CONNECTION_FAILED = 'api-connection-failed';

/** Observe transport failures without changing requests, responses or save retries. */
export const monitorApiFetch = (
  fetcher: typeof fetch,
  apiBaseUrl: string,
  pageUrl: string,
  onFailure: () => void,
): typeof fetch => {
  const base = apiBaseUrl ? new URL(apiBaseUrl, pageUrl) : null;
  const basePath = base?.pathname.replace(/\/$/, '') || '';
  return async (input, init) => {
    const request = typeof Request !== 'undefined' && input instanceof Request ? input : null;
    const url = new URL(request ? request.url : String(input), pageUrl);
    const isApi = base !== null && url.origin === base.origin
      && (url.pathname === basePath || url.pathname.startsWith(`${basePath}/`));
    try {
      const response = await fetcher(input, init);
      if (isApi && [502, 503, 504, 521, 522, 523, 524].includes(response.status)) onFailure();
      return response;
    } catch (error) {
      const signal = init?.signal ?? request?.signal;
      if (isApi && !signal?.aborted && error instanceof Error
        && (error.name === 'TypeError' || error.name === 'TimeoutError')) onFailure();
      throw error;
    }
  };
};
